export default __webpack_public_path__ + "static/Demo_German_Accent_American-4ddb0ecbde64cee8ec8c70d5a2c2e738.mp3";